enum RichDataSource {
    SaaScada = "SAASCADA",
    ClearBank = "CLEARBANK",
    GPS = "GPS",
    Swisscom = "SWISSCOM",
}
export default RichDataSource;